/* Emmafy in-cart upsells — instant Add with drawer refresh (event-delegated, survives re-renders) */
(function () {
  'use strict';

  var ROOT_PATH = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addToCart(items) {
    return fetch(ROOT_PATH + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || (data.status && data.status !== 200)) {
          throw new Error(data.description || data.message || 'Add failed');
        }
        return data;
      });
    });
  }

  function wireDrawerClose(drawerEl) {
    var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.dataset.emWired) {
      overlay.dataset.emWired = '1';
      overlay.addEventListener('click', function () { closeDrawer(drawerEl); });
    }
    var closeBtn = drawerEl.querySelector('.drawer__close');
    if (closeBtn && !closeBtn.dataset.emWired) {
      closeBtn.dataset.emWired = '1';
      closeBtn.addEventListener('click', function () { closeDrawer(drawerEl); });
    }
  }

  function closeDrawer(drawerEl) {
    if (typeof drawerEl.close === 'function') drawerEl.close();
    else { drawerEl.classList.remove('active'); document.body.classList.remove('overflow-hidden'); }
  }

  function refreshDrawer(open) {
    return fetch(ROOT_PATH + '?sections=cart-drawer,cart-icon-bubble&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');
        if (!drawerEl || !sections['cart-drawer']) throw new Error('no drawer');
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        var freshInner = tmp.querySelector('#CartDrawer');
        var curInner = drawerEl.querySelector('#CartDrawer');
        if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
        else if (freshInner) drawerEl.innerHTML = freshInner.outerHTML;
        drawerEl.classList.remove('is-empty');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var t2 = document.createElement('div');
          t2.innerHTML = sections['cart-icon-bubble'];
          var fb = t2.querySelector('.shopify-section');
          bubble.innerHTML = fb ? fb.innerHTML : sections['cart-icon-bubble'];
        }
        if (open) {
          if (typeof drawerEl.open === 'function') drawerEl.open();
          else { document.body.classList.add('overflow-hidden'); drawerEl.classList.add('animate', 'active'); }
        }
        wireDrawerClose(drawerEl);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-em-cu-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var card = btn.closest('[data-em-cu]');
    var sel = card.querySelector('.em-cu__select');
    var hidden = card.querySelector('.em-cu__single');
    var id = parseInt(sel ? sel.value : (hidden ? hidden.value : ''), 10);
    if (!id) return;
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    addToCart([{ id: id, quantity: 1 }])
      .then(function () { return refreshDrawer(true); })
      .catch(function () { window.location.href = ROOT_PATH + 'cart'; })
      .finally(function () { btn.disabled = false; btn.textContent = prev; });
  });

  // wire close handlers on initial load too
  function boot() {
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) wireDrawerClose(drawerEl);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
